import React, { useEffect, useState, useRef, useContext } from "react";
import moment from "moment-timezone";
import FadeIn from "react-fade-in";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "@fullcalendar/core/main";
import "@fullcalendar/daygrid/main";

import sad from "../assets/images/moods/ic_sad.png";
import unhappy from "../assets/images/moods/ic_unhappy.png";
import okay from "../assets/images/moods/ic_okay.png";
import happy from "../assets/images/moods/ic_happy.png";
import elated from "../assets/images/moods/ic_elated.png";
import axios from "axios";

import { GET_MOOD_CAPTURE_CALENDAR } from "../Routes";
import { generateURLOptions } from "../URLOptions";
import { UserContext } from "../storage/contexts/UserContext";

const Calendar = () => {
  const { profile } = useContext(UserContext);
  const calendarComponentRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);

  const [date, setDate] = useState(
    moment.tz(profile?.timezone ?? "Australia/Adelaide").toISOString(),
  );
  const [calendarData, setCalendarData] = useState([]);
  const [eventData, setEventData] = useState([]);

  useEffect(() => {
    getCalendarData();
  }, [date]);

  useEffect(() => {
    renderCalendarData();
  }, [calendarData]);

  const getCalendarData = async () => {
    setCalendarData([]);
    setEventData([]);
    await axios
      .post(
        GET_MOOD_CAPTURE_CALENDAR,
        {
          date: date,
        },
        {
          headers: generateURLOptions(),
        },
      )
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        console.log("Calendar data: ", response);
        setCalendarData(response.data?.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error) => {
        console.log("Get Mood Capture Calendar Data Error: ", error);
        return alert(error);
      });
  };

  const renderCalendarData = () => {
    if (calendarData?.length <= 0) return;
    let eData = [];
    calendarData?.map((item) => {
      const titleChange =
        item.moodType === "log"
          ? "Checkin"
          : item.moodType === "sl"
            ? "OL"
            : item.moodType == "dfl"
              ? "DFL"
              : "";
      const moodType =
        item.mood === 0
          ? sad
          : item.mood === 1
            ? unhappy
            : item.mood === 2
              ? okay
              : item.mood === 3
                ? happy
                : item.mood === 4
                  ? elated
                  : "";
      eData.push({
        id: item?._id,
        title: titleChange,
        image: moodType,
        date: moment(item?.logDate)
          .tz(profile?.timezone ?? "Australia/Adelaide")
          .toISOString(),
      });
    });

    setEventData(eData);
  };

  const renderEventContent = (eventInfo) => (
    <div className="px-2 w-full flex flex-col justify-center items-center">
      {eventInfo?.event?.title === "Checkin" ? (
        <img
          className="w-8 h-8 object-contain"
          src={eventInfo?.event?.extendedProps?.image ?? ""}
          alt="mood"
        />
      ) : (
        <p className="text-black font-medium text-base">
          {eventInfo.event.title}
        </p>
      )}
    </div>
  );

  return (
    <>
      {!isLoading ? (
        <FadeIn>
          <style>
            {`
                      .fc-daygrid-day-events {
                        display: flex !important;
                        justify-content: center !important;
                        align-items: center !important;
                        min-height: 40px !important;
                      }
                      .fc-daygrid-event-harness {
                        position: relative !important;
                        margin: 0 auto !important;
                      }
                      .fc-event {
                        background: transparent !important;
                        border: none !important;
                      }
                    `}
          </style>
          <FullCalendar
            height={"75vh"}
            ref={calendarComponentRef}
            plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
            defaultView="dayGridMonth"
            customButtons={{
              prev: {
                click: function () {
                  let calendarApi = calendarComponentRef.current.getApi();
                  calendarApi.prev();
                  const currentDate =
                    calendarApi.currentDataManager.data.currentDate;

                  console.log("PREVIOUS DATE: ", currentDate);
                  setDate(moment(currentDate).toISOString());
                },
              },
              next: {
                click: function () {
                  let calendarApi = calendarComponentRef.current.getApi();
                  calendarApi.next();
                  const currentDate =
                    calendarApi.currentDataManager.data.currentDate;

                  console.log("NEW DATE: ", currentDate);
                  setDate(moment(currentDate).toISOString());
                },
              },
            }}
            headerToolbar={{
              left: "prev",
              center: "title",
              right: "next",
            }}
            dayMaxEvents={1}
            firstDay={1}
            eventDisplay="block"
            events={eventData}
            eventContent={renderEventContent}
          />
        </FadeIn>
      ) : (
        <div className="h-[70vh] relative flex flex-col justify-center items-center z-50">
          <div
            className="h-10 w-10 rounded-full border-4 border-mpPurple/30 border-t-mpPurple animate-spin"
            style={{ marginTop: 12, marginBottom: 12 }}
          />
          <h6 className="text-black font-medium">Updating Calendar</h6>
        </div>
      )}
    </>
  );
};

export default Calendar;
